// import React, { useState, useEffect } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import CanceledPlotsList from "./CanceledPlotsList";
// import CancelPlotDetails from "./CancelPlotDetails";
// import RefundInstallmentsTable from "./RefundInstallmentsTable";
// import ProcessRefundModal from "./ProcessRefundModal";
// import {
//   getCancelPlotDetailsThunk,
//   getRefundInstallmentsThunk,
//   getCanceledPlotsThunk, // Add this import
// } from "../store/slices/plotCancellationSlice";

// const PlotCancellationManagement = () => {
//   const dispatch = useDispatch();
//   const [selectedCancelPlotId, setSelectedCancelPlotId] = useState(null);
//   const [showRefundModal, setShowRefundModal] = useState(false);
//   const [detailsLoading, setDetailsLoading] = useState(false);
//   const [isExpanded, setIsExpanded] = useState(false);

//   // Get plots from Redux state
//   const { canceledPlots = [], selectedPlotDetails } = useSelector(
//     (state) => state.cancelPlot
//   );
//   const { users = [] } = useSelector((state) => state.auth);

//   // Fetch canceled plots and details when component mounts
//   useEffect(() => {
//     // Dispatch to fetch canceled plots
//     dispatch(getCanceledPlotsThunk({})); // You can pass filters if needed
//   }, [dispatch]);

//   // Fetch details when a plot is selected
//   useEffect(() => {
//     if (selectedCancelPlotId) {
//       setDetailsLoading(true);

//       Promise.all([
//         dispatch(getCancelPlotDetailsThunk(selectedCancelPlotId)),
//         dispatch(getRefundInstallmentsThunk(selectedCancelPlotId)),
//       ])
//         .then(() => {
//           setDetailsLoading(false);
//         })
//         .catch(() => {
//           setDetailsLoading(false);
//         });
//     }
//   }, [dispatch, selectedCancelPlotId]);

//   // Handle plot selection
//   const handlePlotSelect = (id) => {
//     setSelectedCancelPlotId(id);
//     // Mobile responsiveness - expand details on selection
//     setIsExpanded(true);
//   };

//   // Handle process refund
//   const handleProcessRefund = () => {
//     setShowRefundModal(true);
//   };

//   // Log canceled plots for debugging
//   useEffect(() => {
//     console.log("Canceled Plots Received:", canceledPlots);
//   }, [canceledPlots]);

//   return (
//     <div className="bg-gradient-to-br from-slate-800 via-slate-900 to-slate-800 min-h-screen p-8">
//       <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-3 gap-6">
//         {/* Left Column: Canceled Plots List */}
//         <div className="lg:col-span-1">
//           <div className="backdrop-blur-md bg-slate-800/50 rounded-2xl border border-teal-500/20 shadow-xl">
//             <div className="p-5 border-b border-teal-500/20">
//               <h2 className="text-teal-300 font-semibold flex items-center text-xl">
//                 <svg
//                   xmlns="http://www.w3.org/2000/svg"
//                   className="h-6 w-6 mr-2"
//                   fill="none"
//                   viewBox="0 0 24 24"
//                   stroke="currentColor"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
//                   />
//                 </svg>
//                 Canceled Plots
//               </h2>
//             </div>

//             <CanceledPlotsList
//               canceledPlots={canceledPlots || []}
//               onSelectPlot={handlePlotSelect}
//               selectedId={selectedCancelPlotId}
//               users={users}
//             />
//           </div>
//         </div>

//         {/* Right Columns: Plot Details and Installments */}
//         <div className="lg:col-span-2 space-y-6">
//           {/* Plot Details Section */}
//           {selectedCancelPlotId && selectedPlotDetails ? (
//             <div className="backdrop-blur-md bg-slate-800/50 rounded-2xl border border-teal-500/20 shadow-xl">
//               {detailsLoading ? (
//                 <div className="p-10 flex items-center justify-center">
//                   <p className="text-teal-300 text-lg">Loading details...</p>
//                 </div>
//               ) : (
//                 <CancelPlotDetails
//                   plotDetails={selectedPlotDetails}
//                   onProcessRefund={handleProcessRefund}
//                   users={users}
//                   isExpanded={isExpanded}
//                 />
//               )}
//             </div>
//           ) : (
//             <div className="backdrop-blur-md bg-slate-800/50 rounded-2xl border border-teal-500/20 p-10 flex items-center justify-center">
//               <p className="text-teal-300 text-lg">
//                 Select a plot to view its details
//               </p>
//             </div>
//           )}

//           {/* Refund Installments Section */}
//           {selectedCancelPlotId && !detailsLoading && (
//             <div className="backdrop-blur-md bg-slate-800/50 rounded-2xl border border-teal-500/20 shadow-xl">
//               <RefundInstallmentsTable />
//             </div>
//           )}
//         </div>
//       </div>

//       {/* Modals */}
//       {showRefundModal && (
//         <ProcessRefundModal
//           cancelPlotId={selectedCancelPlotId}
//           onClose={() => setShowRefundModal(false)}
//         />
//       )}
//     </div>
//   );
// };

// export default PlotCancellationManagement;

import React, { useState, useEffect, useCallback, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSidebarContext } from "../scenes/global/sidebar/SidebarContext";
import {
  getCancelPlotDetailsThunk,
  getRefundInstallmentsThunk,
  getCanceledPlotsThunk,
} from "../store/slices/plotCancellationSlice";

// Component imports
import CanceledPlotsList from "./CanceledPlotsList";
import CancelPlotDetails from "./CancelPlotDetails";
import RefundInstallmentsTable from "./RefundInstallmentsTable";
import ProcessRefundModal from "./ProcessRefundModal";

const PlotCancellationManagement = () => {
  const dispatch = useDispatch();
  const { activeSociety, theme } = useSidebarContext();

  // Local state
  const [selectedCancelPlotId, setSelectedCancelPlotId] = useState(null);
  const [showRefundModal, setShowRefundModal] = useState(false);
  const [detailsLoading, setDetailsLoading] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const [isInitialLoad, setIsInitialLoad] = useState(true);

  // Get data from Redux state
  const {
    canceledPlots = [],
    selectedPlotDetails,
    loading,
  } = useSelector((state) => state.cancelPlot);
  const { users = [] } = useSelector((state) => state.auth);

  // Filter plots by active society - memoize to prevent recalculations
  const filteredPlots = useCallback(() => {
    if (!canceledPlots || !Array.isArray(canceledPlots)) return [];

    return activeSociety
      ? canceledPlots.filter(
          (plot) => plot?.plot_id?.society_id === activeSociety?._id
        )
      : canceledPlots;
  }, [canceledPlots, activeSociety]);

  // Fetch canceled plots ONLY when component mounts and prevent duplicate requests
  useEffect(() => {
    if (isInitialLoad) {
      dispatch(getCanceledPlotsThunk({}))
        .then(() => {
          setIsInitialLoad(false);
        })
        .catch((error) => {
          console.error("Error fetching canceled plots:", error);
          setIsInitialLoad(false);
        });
    }
  }, [dispatch, isInitialLoad]);

  // Fetch details when a plot is selected - but only when ID changes and not already loading
  useEffect(() => {
    if (selectedCancelPlotId) {
      setDetailsLoading(true);

      Promise.all([
        dispatch(getCancelPlotDetailsThunk(selectedCancelPlotId)),
        dispatch(getRefundInstallmentsThunk(selectedCancelPlotId)),
      ])
        .then(() => {
          setDetailsLoading(false);
        })
        .catch((error) => {
          console.error("Error fetching plot details:", error);
          setDetailsLoading(false);
        });
    }
  }, [dispatch, selectedCancelPlotId]);

  // Handle plot selection - prevent reselecting the same plot
  const handlePlotSelect = (id) => {
    if (id === selectedCancelPlotId) return;
    setSelectedCancelPlotId(id);
    setIsExpanded(true); // Expand details panel on mobile
  };

  const handleProcessRefund = () => {
    setShowRefundModal(true);
  };

  const memoizedFilteredPlots = filteredPlots();

  return (
    <div className="min-h-screen w-full p-4 md:p-6 lg:p-8">
      {/* Page Header */}
      <div className="mb-6">
        <div className="flex flex-col md:flex-row md:items-center justify-between">
          <div>
            <h1 className={`text-2xl md:text-3xl font-bold ${theme.textColor}`}>
              Plot Cancellation Management
            </h1>
            <p className="text-slate-300 mt-1">
              {activeSociety
                ? `${activeSociety.name} - ${activeSociety.location}`
                : "All Societies"}
            </p>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="grid grid-cols-1 gap-6">
        {/* Left Column: Canceled Plots List */}
        <div className="backdrop-blur-md bg-slate-800/50 rounded-2xl border border-teal-500/20 shadow-xl h-full">
          <div className="p-5 border-b border-teal-500/20">
            <h2 className="text-teal-300 font-semibold flex items-center text-xl">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6 mr-2"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                />
              </svg>
              Canceled Plots Under Installments
            </h2>
          </div>

          {loading || isInitialLoad ? (
            <div className="p-10 flex items-center justify-center">
              <div className="animate-pulse flex space-x-2">
                <div className="h-3 w-3 bg-teal-400 rounded-full"></div>
                <div className="h-3 w-3 bg-teal-400 rounded-full"></div>
                <div className="h-3 w-3 bg-teal-400 rounded-full"></div>
              </div>
            </div>
          ) : memoizedFilteredPlots.length > 0 ? (
            <CanceledPlotsList
              canceledPlots={memoizedFilteredPlots}
              onSelectPlot={handlePlotSelect}
              selectedId={selectedCancelPlotId}
              users={users}
            />
          ) : (
            <div className="p-10 flex items-center justify-center">
              <p className="text-slate-400 text-center">
                No canceled plots found {activeSociety ? "in this society" : ""}
              </p>
            </div>
          )}
        </div>

        {/* Right Columns: Plot Details and Installments */}
        {/* Plot Details Section */}
        <div className="backdrop-blur-md bg-slate-800/50 rounded-2xl border border-teal-500/20 shadow-xl">
          <div className="p-5 border-b border-teal-500/20">
            <h2 className="text-teal-300 font-semibold flex items-center text-xl">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6 mr-2"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7"
                />
              </svg>
              Plot Cancellation Details
            </h2>
          </div>

          {selectedCancelPlotId ? (
            detailsLoading ? (
              <div className="p-10 flex items-center justify-center">
                <div className="animate-pulse flex space-x-2">
                  <div className="h-3 w-3 bg-teal-400 rounded-full"></div>
                  <div className="h-3 w-3 bg-teal-400 rounded-full"></div>
                  <div className="h-3 w-3 bg-teal-400 rounded-full"></div>
                </div>
              </div>
            ) : selectedPlotDetails ? (
              <CancelPlotDetails
                plotDetails={selectedPlotDetails}
                onProcessRefund={handleProcessRefund}
                users={users}
                isExpanded={isExpanded}
              />
            ) : (
              <div className="p-10 flex items-center justify-center">
                <p className="text-slate-400 text-center">
                  No details available for the selected plot
                </p>
              </div>
            )
          ) : (
            <div className="p-10 flex flex-col items-center justify-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-16 w-16 text-slate-500 mb-4"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={1}
                  d="M8 16l2.879-2.879m0 0a3 3 0 104.243-4.242 3 3 0 00-4.243 4.242zM21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
              <p className="text-slate-400 text-center">
                Select a plot from the list to view its cancellation details
              </p>
            </div>
          )}
        </div>

        {/* Refund Installments Section */}
        {selectedCancelPlotId && selectedPlotDetails && (
          <div className="backdrop-blur-md bg-slate-800/50 rounded-2xl border border-teal-500/20 shadow-xl">
            <div className="p-5 border-b border-teal-500/20">
              <h2 className="text-teal-300 font-semibold flex items-center text-xl">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6 mr-2"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
                Refund Installments
              </h2>
            </div>
            <RefundInstallmentsTable />
          </div>
        )}
      </div>

      {/* Modals */}
      {showRefundModal && (
        <ProcessRefundModal
          cancelPlotId={selectedCancelPlotId}
          onClose={() => setShowRefundModal(false)}
        />
      )}
    </div>
  );
};

export default PlotCancellationManagement;
